import { observer } from 'mobx-react';
import { FC, PropsWithChildren, ReactElement } from 'react';

import { FeatureType } from '@fleet-pro/mobile-webview-api';

import { useFeaturesChecker } from '../hooks/use-feature-checker';
import { FeatureMatchType } from '../utils/has-features';

export interface FeatureCheckerProps {
    features: FeatureType[];
    featureType?: FeatureMatchType;
    fallback?: ReactElement;
}

export const FeatureChecker: FC<PropsWithChildren<FeatureCheckerProps>> = observer(
    ({ features, children, featureType, fallback = null }) => {
        const hasAllFeatures = useFeaturesChecker(features, featureType);

        return hasAllFeatures ? children : fallback;
    }
);
